module.exports = __webpack_public_path__ + "media/assets/images/icons/profile-generic/avatar-class-17a81f6a7079d177ee70cd1e4e18410c.png";